import { createContext } from "react";
import socketio from "socket.io-client";
import config from "../config";

export const socket = socketio;
export const SocketContext = createContext();